(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  const initialize = root => {
    if (root.dataset.initialized) return;
    const words = JSON.parse(root.querySelector('[data-mr-strings]').textContent);
    const listing = root.querySelector('[data-mr-listing]');
    const detailsRegion = root.querySelector('[data-mr-details]');
    const recipes = [...root.querySelectorAll('[data-mr-recipe]')];
    const grid = root.querySelector('.mr-grid');
    const search = root.querySelector('[data-mr-search]');
    const count = root.querySelector('[data-mr-count]');
    const empty = root.querySelector('[data-mr-empty]');
    const buttons = [...root.querySelectorAll('[data-mr-filter]')];
    const stage = root.querySelector('[data-mr-stage]');
    const duration = root.querySelector('[data-mr-duration]');
    const order = root.querySelector('[data-mr-order]');
    const more = root.querySelector('[data-mr-more]');
    const parseList = source => { try { const value = JSON.parse(source || '[]'); return Array.isArray(value) ? value : []; } catch { return []; } };
    const draftIndex = parseList(root.querySelector('[data-mr-drafts]')?.textContent).filter((item, index, rows) => item && typeof item.id === 'string' && /^receta-v5-clu-\d{4}$/.test(item.id) && ['breakfast','lunch','snack','dessert'].includes(item.category) && typeof item.title === 'string' && rows.findIndex(row => row?.id === item.id) === index);
    const draftUrls = JSON.parse(root.querySelector('[data-mr-draft-urls]')?.textContent || '{}');
    const loadStatus = root.querySelector('[data-mr-load-status]');
    const recipeImages = new Map(JSON.parse(root.querySelector('[data-mr-images]')?.textContent || '[]').map(item => [item.id, item]));
    const articleUrls = JSON.parse(root.querySelector('[data-mr-article-urls]')?.textContent || '{}');
    const cache = new Map();
    let loadToken = 0;
    let category = 'all', limit = 12, active = null, returnTarget = null, returnScroll = 0;
    const records = [...grid.querySelectorAll('[data-mr-card]')].map((card, index) => ({
      id: card.querySelector('[data-mr-open]').dataset.mrOpen,
      title: card.querySelector('h2').textContent, category: card.dataset.category,
      text: [card.dataset.search, words[card.dataset.category]].join(' '), total: Number(card.dataset.minutes) || null,
      status: 'ready', card, index
    }));
    const make = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };
    const imageFor = (id, title, className) => {
      const item = recipeImages.get(id);
      if (!item || typeof item.url !== 'string' || typeof item.thumbnail !== 'string') return null;
      let source, thumbnail;
      try { source = new URL(item.url, location.origin); thumbnail = new URL(item.thumbnail, location.origin); } catch { return null; }
      if ([source, thumbnail].some(url => url.protocol !== 'https:' || ![location.hostname, 'cdn.shopify.com'].includes(url.hostname))) return null;
      const image = make('img', className);
      image.src = className === 'mr-card-image' ? thumbnail.href : source.href; image.alt = title; image.width = item.width; image.height = item.height;
      image.loading = 'lazy'; image.decoding = 'async';
      return image;
    };
    draftIndex.forEach((item, index) => {
      const card = make('article', 'mr-card mr-concept-card');
      card.setAttribute('data-mr-card', '');
      card.dataset.category = item.category;
      card.dataset.draftId = item.id; card.dataset.minutes = String(item.total);
      const picture = imageFor(item.id, item.title, 'mr-card-image');
      if (picture) { const photo = make('div', 'mr-card-photo'); photo.append(picture); card.append(photo); }
      const body = make('div', 'mr-card-body');
      body.append(make('span', 'mr-category', words[item.category]), make('h2', '', item.title), make('p','mr-time', `${words.total}: ${item.total} min`));
      const articleUrl = typeof articleUrls[item.id] === 'string' && articleUrls[item.id].startsWith('/blogs/recetas/') ? articleUrls[item.id] : null;
      const button = make(articleUrl ? 'a' : 'button', 'mr-link', words.view_concept);
      if (articleUrl) { button.href = articleUrl; button.dataset.mrArticle = 'true'; }
      else button.type = 'button';
      button.dataset.mrOpen = item.id;
      button.setAttribute('aria-label', `${words.view_concept}: ${item.title}`);
      body.append(button); card.append(body);
      records.push({ ...item, text: [item.title, item.text, ...(item.aliases || []), words[item.category]].join(' '), total: item.total, status: 'new', card, index: index + 14 });
    });
    const message = (template, vars) => template.replace(/\{(\w+)\}/g, (_, key) => vars[key] ?? '');
    const filter = (reset = true) => {
      if (reset) limit = 12;
      const query = normalize(search.value).split(/\s+/).filter(Boolean);
      const matches = records.filter(item => (category === 'all' || item.category === category)
        && (!stage || stage.value === 'all' || item.status === stage.value)
        && (duration.value === 'all' || (item.total !== null && item.total <= Number(duration.value)))
        && query.every(word => normalize(item.text).includes(word)));
      matches.sort((a, b) => order.value === 'az' ? a.title.localeCompare(b.title, 'es')
        : order.value === 'time' ? (a.total ?? Infinity) - (b.total ?? Infinity) || a.title.localeCompare(b.title, 'es')
        : a.index - b.index);
      records.forEach(item => { item.card.hidden = true; });
      matches.forEach((item, index) => { item.card.hidden = index >= limit; grid.append(item.card); });
      const shown = Math.min(limit, matches.length);
      count.textContent = message(words.results, {shown, total:matches.length});
      count.dataset.total = String(matches.length);
      count.dataset.shown = String(shown);
      more.hidden = shown >= matches.length;
      more.textContent = message(words.more, {count: Math.min(12, matches.length - shown)});
      empty.hidden = matches.length !== 0;
    };
    const renderDraft = item => {
      const detail = make('details','mr-recipe'); detail.id = item.id;
      detail.dataset.mrRecipe = ''; detail.dataset.pasteurized = String(item.pasteurized); detail.open = true;
      detail.append(make('summary','',item.title));
      const article = make('article','mr-recipe-body');
      const toolbar = make('div','mr-detail-toolbar mr-only-js');
      const back = make('a','',`← ${words.back}`); back.href = '#recetas'; back.dataset.mrBack = '';
      const print = make('button','mr-button',words.print); print.type = 'button'; print.dataset.mrPrint = '';
      toolbar.append(back,print); article.append(toolbar);
      const picture = imageFor(item.id, item.title, 'mr-detail-image');
      const intro = make('div', picture ? 'mr-detail-intro' : 'mr-detail-intro mr-detail-intro--text');
      const introduction = make('div');
      if (picture) intro.append(picture); intro.append(introduction);
      const title = make('h2','',item.title); title.tabIndex = -1;
      introduction.append(make('span','mr-category',words[item.category]),title,make('p','',item.description),make('p','mr-yield',item.yield));
      const timing = make('div','mr-timings');
      for (const key of ['prep','cook','rest','chill','total']) if (item.timing[key] > 0) timing.append(make('span','',`${words[key]}: ${item.timing[key]} min`));
      introduction.append(timing); article.append(intro,make('p','mr-safety',item.safety));
      const columns = make('div','mr-detail-columns');
      for (const [key,tag] of [['ingredients','ul'],['steps','ol']]) {
        const section = make('section'),list = make(tag);
        for (const text of item[key]) list.append(make('li','',text));
        section.append(make('h3','',words[key]),list); columns.append(section);
      }
      article.append(columns);
      const notes = make('div','mr-notes');
      for (const text of item.notes) notes.append(make('p','',text));
      for (const [url,text] of [[item.food_safety_source,words.safety_source],[item.support,words.technique_source]]) {
        if (!url) continue;
        const parsed = new URL(url);
        if (parsed.protocol !== 'https:') continue;
        const link = make('a','',`${text} ↗`);link.href = parsed.href;link.target = '_blank';link.rel = 'noopener noreferrer';
        const line = make('p');line.append(link);notes.append(line);
      }
      article.append(notes);detail.append(article);detailsRegion.append(detail);recipes.push(detail);
      return detail;
    };
    const ensureDraft = async id => {
      const meta = draftIndex.find(item => item.id === id);
      if (!meta || !draftUrls[meta.category]) return null;
      if (!cache.has(meta.category)) {
        cache.set(meta.category, fetch(draftUrls[meta.category],{credentials:'omit'}).then(async response => {
          if (!response.ok) throw new Error('Recipe asset unavailable');
          const body = await response.json();
          if (!Array.isArray(body.recipes)) throw new Error('Invalid recipe asset');
          return body.recipes.filter(row => draftIndex.some(meta => meta.id === row.id && meta.category === row.category));
        }).catch(error => {cache.delete(meta.category);throw error;}));
      }
      const rows = await cache.get(meta.category),item = rows.find(row => row.id === id);
      if (!item || !Array.isArray(item.ingredients) || !Array.isArray(item.steps)) throw new Error('Recipe missing');
      return recipes.find(recipe => recipe.id === id) || renderDraft(item);
    };
    const show = async (id, focus = false) => {
      const token = ++loadToken;
      let next = recipes.find(recipe => recipe.id === id) || null;
      if (!next && draftIndex.some(item => item.id === id)) {
        loadStatus.hidden = false;loadStatus.textContent = words.loading_recipe;
        try {next = await ensureDraft(id);} catch {
          if (token === loadToken) {loadStatus.textContent = words.load_error;loadStatus.hidden = false;}
          return false;
        }
      }
      if (token !== loadToken) return false;
      if (loadStatus) loadStatus.hidden = true;
      active = next;listing.hidden = Boolean(active);detailsRegion.hidden = !active;
      recipes.forEach(recipe => {recipe.hidden = recipe !== active;recipe.open = recipe === active;});
      if (focus && active) {active.querySelector('h2').focus({preventScroll:true});root.scrollIntoView({block:'start',behavior:'instant'});}
      return Boolean(active);
    };

    const reset = () => {
      category = 'all'; search.value = ''; duration.value = 'all'; order.value = 'recommended';
      if (stage) stage.value = 'all';
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mrFilter === 'all')));
      filter();
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.mrFilter;
      buttons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
      filter();
    }));
    search.addEventListener('input', () => filter());
    [stage, duration, order].filter(Boolean).forEach(select => select.addEventListener('change', () => filter()));
    more.addEventListener('click', () => {
      const previous = limit; limit += 12; filter(false);
      const visible = [...grid.querySelectorAll('[data-mr-card]')].filter(card => !card.hidden);
      visible[previous]?.querySelector('a,button')?.focus({preventScroll:true});
    });
    root.querySelectorAll('[data-mr-clear]').forEach(button => button.addEventListener('click', reset));
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-mr-open]');
      if (link?.dataset.mrArticle === 'true') return;
      if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault(); returnTarget = link; returnScroll = window.scrollY;
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy','true');
        const shown = await show(link.dataset.mrOpen, true);
        link.removeAttribute('aria-busy');
        if (shown) history.pushState({...history.state, mrRecipe:link.dataset.mrOpen}, '', `#${link.dataset.mrOpen}`);
      }
      if (event.target.closest('[data-mr-back]')) {
        event.preventDefault();
        if (history.state?.mrRecipe) history.back();
        else { history.replaceState(history.state, '', `${location.pathname}${location.search}#recetas`); show(null); root.querySelector('h1').focus({preventScroll:true}); }
      }
      if (event.target.closest('[data-mr-print]') && active) {
        document.body.classList.add('mr-printing'); window.print();
      }
    });
    const sync = async () => {
      await show(location.hash.slice(1));
      if (active) show(active.id, true);
      else if (returnTarget && !returnTarget.closest('[hidden]')) {
        returnTarget.focus({preventScroll:true}); window.scrollTo({top:returnScroll, behavior:'instant'});
      }
    };
    window.addEventListener('popstate', sync); window.addEventListener('hashchange', sync);
    window.addEventListener('afterprint', () => document.body.classList.remove('mr-printing'));
    root.dataset.initialized = 'true'; root.classList.add('mr-enhanced');
    root.querySelector('[data-mr-controls]').hidden = false;
    show(location.hash.slice(1)); filter();
  };
  document.querySelectorAll('[data-memys-recetas]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-memys-recetas]').forEach(initialize));
})();
